export function print(){

    window.addEventListener('beforeprint', () => {
        document.querySelectorAll('img[loading="lazy"]').forEach((img) => {
            
            // If the image is not loaded, force-load it
            if (!img.complete) {
                img.loading = 'eager';
                img.src = img.src; // Trigger re-loading
            }
        });
        let printLogo = document.querySelector("body").getAttribute("data-print-logo") == "true" ? true : false; // Get the main logo
        let logoUrl = printLogo && document.querySelector(".nav-brand img") ? document.querySelector(".nav-brand img").src : ''; // Get the main logo
        let titleElement = document.querySelector("main h1") ? document.querySelector("main h1").innerText : ''; // Get the title of the page
        
        let title = titleElement// Get the page title
        let today = new Date().toLocaleDateString(); // Get the current date
        
        // Create a single style tag
        let styleTag = document.createElement("style");
        
          styleTag.setAttribute("data-print-style", "true");
          styleTag.innerHTML = `
      
              @page {
                  @top-left {
                      content: url("${logoUrl}");
                  }
                  @bottom-left {
                      font-size: 10px;
                      content: "${title}";
                  }
                  @bottom-right {
                      content: "${today}";
                      font-size: 10px
                  }
              }
          `;
      
          document.head.appendChild(styleTag); // Append dynamic CSS to the document
    })


}

export default print;